import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarComponent from "../../../components/calendar";
import AppLoader from "../../../components/loader";
import {
  getfollowUpDates,
  getFutureContract,
} from "../../../services/ContractApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import { Box } from "@mui/material";

const FutureContract = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allFutureContract, setAllFutureContract] = useState([]);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);


  useEffect(() => {
    fetchFutureContract();
  }, []);

  const fetchFutureContract = async () => {
    setIsLoading(true);
    try {
      const response = await getFutureContract(
        searchKeys.selectedAgentsForCalendar
      );

      if (response.data.status === "success") {
        const data = response.data.data;
        const result = [];

        data
          ?.filter((x) => x.liveDates?.length > 0)
          .forEach((x) => {
            const liveDate = new Date(x.liveDates[0]);

            // Main event (actual live date)
            result.push({
              id: x._id,
              type: "lead",
              title: `${x.title} ${x.customer}` || "NA",
              businessName: x.businessName || "NA",
              start: liveDate,
              end: liveDate,
              contact: x.contact || "NA",
              agentName: x.agentName || "NA",
              note: x.note || "NA",
              colorCode: "#90EE90",
              allDay: true,
              isReminder: false,
              address: x.address || "NA",
            });

            // Reminder event (14 days before)
            const reminderDate = new Date(liveDate);
            reminderDate.setDate(reminderDate.getDate() - 14);

            result.push({
              id: `${x._id}-reminder`,
              type: "lead",
              title: `${x.title} ${x.customer}` || "NA",
              businessName: x.businessName || "NA",
              start: reminderDate,
              end: reminderDate,
              contact: x.contact || "NA",
              agentName: x.agentName || "NA",
              note: x.note || "NA",
              colorCode: "#ADD8E6",
              allDay: true,
              isReminder: true,
              actualData: liveDate,
              address: x.address || "NA",
            });
          });


        setAllFutureContract(result);
      } else {
        handleOpenSnackBar(response.data.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />

      <CalendarComponent
        data={allFutureContract || []}
        title={"Future Contracts"}
        dataType="contract_base"
      />
    </Box>
  );
};

export default FutureContract;
